__turbopack_context__.v({
  "arrow": "mphq7G_arrow",
  "content": "mphq7G_content",
  "contentIn": "mphq7G_contentIn",
  "contentOut": "mphq7G_contentOut",
  "withShortcut": "mphq7G_withShortcut",
});
